<template>
  <div class="login-page">
    <div class="login-body" :class="{ weChatBody: showWeChatBody }">
      <div class="logo_big">
        <img class="logo-image" src="../assets/img/shiji-logo-v2.png" />
      </div>
      <div class="logo_small">
        <img class="logo-image" src="../assets/img/shiji-logo-white.png" />
      </div>

      <div class="shiji-email-content">
        <h1 class="login-h1" v-show="showLanguage == 'en' || !showLanguage">
          Log In Using ShiJi Email Credential
        </h1>
        <h1 class="login-h1" v-show="showLanguage == 'zh' || !showLanguage">
          使用石基邮箱凭据登录
        </h1>

        <el-form
          ref="form"
          class="shiji-email-form"
          :model="form"
          @submit.native.prevent="login"
        >
          <div class="ac-field">
            <label class="label-size">
              <span v-show="showLanguage == 'en' || !showLanguage">Tenant</span>
              <span v-show="!showLanguage"> | </span>
              <span v-show="showLanguage == 'zh' || !showLanguage">环境</span>
            </label>
            <el-input
              ref="TenantId"
              v-model="form.tenant"
              class="animation"
              size="small"
              :placeholder="fillName"
              autocomplete="off"
              required
            ></el-input>
          </div>

          <div class="shiji-email-actions">
            <button type="submit" class="loginButton">
              <span v-show="showLanguage == 'en' || !showLanguage">Login</span>
              <span v-show="!showLanguage"> | </span>
              <span v-show="showLanguage == 'zh' || !showLanguage">登录</span>
            </button>
          </div>

          <button type="button" class="backLoginButton" @click="backToSepLogin">
            <span class="backArrow">‹</span>
            <span v-show="showLanguage == 'en' || !showLanguage">Back</span>
            <span v-show="!showLanguage"> | </span>
            <span v-show="showLanguage == 'zh' || !showLanguage">返回</span>
          </button>
        </el-form>
      </div>

      <feet v-show="!showFeet" class="shiji-email-footer"></feet>
    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import { mapState } from "vuex";
import feet from "../components/Feet.vue";
import { IDENTITY_ADDRESS } from "../../config-json.js";
import {
  SHIJI_MAIL_PENDING_TENANT_COOKIE,
  buildShijiMailAuthUrl,
  normalizeTenant,
} from "../utils/shijiMailAuth";

const PENDING_LOGIN_DURATION_MS = 10 * 60 * 1000;

export default {
  name: "ShijiEmailLogin",
  components: {
    feet,
  },
  data() {
    return {
      form: {
        tenant: "",
      },
      ReturnUrl: "",
      fillName: "Fill | 必填",
      showFeet: false,
      showWeChatBody: false,
    };
  },
  created() {
    if (!this.processPage) {
      this.$router.replace("/");
      return;
    }

    this.ReturnUrl = this.sanitizeLoginReturnUrl(this.getUrlParam("ReturnUrl"));
    if (this.ReturnUrl) {
      this.getReturnUrlDomain(this);
    }

    if (this.showTenant) {
      this.form.tenant = this.showTenant;
    }

    if (this.showLanguage === "en") {
      this.fillName = "Fill";
    } else if (this.showLanguage === "zh") {
      this.fillName = "必填";
    }

    const isWeChat = this.getUrlParam("isWeChat") === "true";
    this.showFeet = isWeChat;
    this.showWeChatBody = isWeChat;
  },
  mounted() {
    this.focusTenant();
  },
  methods: {
    focusTenant() {
      this.$nextTick(() => {
        if (this.$refs.TenantId) {
          this.$refs.TenantId.focus();
        }
      });
    },
    login() {
      const tenant = normalizeTenant(this.form.tenant);
      if (!tenant || !this.ReturnUrl) {
        this.focusTenant();
        return;
      }

      this.form.tenant = tenant;
      this.startShijiMailLogin(tenant);
    },
    startShijiMailLogin(tenant) {
      const userAgent = window.navigator.userAgent.toLowerCase();
      if (userAgent.match(/MicroMessenger/i) == "micromessenger") {
        wx.miniProgram.getEnv((res) => {
          if (res.miniprogram) {
            this.$router.push("/appletShow");
          } else {
            this.redirectToShijiMail(tenant);
          }
        });
        return;
      }

      this.redirectToShijiMail(tenant);
    },
    redirectToShijiMail(tenant) {
      const expiresAt = new Date(Date.now() + PENDING_LOGIN_DURATION_MS);
      this.$cookies.set(
        SHIJI_MAIL_PENDING_TENANT_COOKIE,
        tenant,
        expiresAt
      );
      window.location.href = buildShijiMailAuthUrl({
        identityAddress: IDENTITY_ADDRESS,
        returnUrl: this.ReturnUrl,
      });
    },
    backToSepLogin() {
      this.$cookies.remove(SHIJI_MAIL_PENDING_TENANT_COOKIE);
      this.$router.replace("/sepLogin");
    },
  },
  computed: {
    ...mapState("returnType", ["showTenant", "showLanguage"]),
    ...mapState("judgeHash", ["processPage"]),
  },
};
</script>

<style scoped>
.shiji-email-content {
  width: 100%;
}

.shiji-email-form {
  margin-top: 28px;
}

.shiji-email-actions {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.backLoginButton {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  margin-top: 12px;
  padding: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: #0c3c6b;
  font-size: 13px;
  font-weight: 400;
}

.backLoginButton:hover {
  cursor: pointer;
  text-decoration: underline;
}

.backLoginButton:focus-visible {
  outline: 2px solid #126aba;
  outline-offset: 3px;
}

.backArrow {
  font-size: 16px;
  line-height: 1;
}

.shiji-email-footer {
  margin-top: auto;
}

@media (max-width: 768px) {
  .weChatBody {
    justify-content: space-evenly !important;
  }

  .login-page {
    position: fixed;
    width: 100%;
    height: 100%;
    background: url("../assets/img/applet.jpg") no-repeat center;
    background-size: cover;
  }

  .login-h1 {
    margin-bottom: 8px;
    color: #fff;
    font-size: 24px;
    font-weight: 400;
  }

  .label-size {
    display: inline-block;
    margin: 4px 0;
    color: #fff;
    font-size: 13px;
    line-height: 1.27;
  }

  .ac-field {
    flex-direction: column;
    padding: 5px 0;
    text-align: left;
  }

  .logo_big {
    display: none;
  }

  .logo_small {
    width: 84px;
    height: 44px;
    margin-bottom: 16px;
    box-sizing: border-box;
  }

  .backLoginButton {
    color: #fff;
  }

  .backLoginButton:focus-visible {
    outline-color: #fff;
  }
}

@media (min-width: 769px) {
  .logo_small {
    display: none;
  }

  .logo_big {
    width: 84px;
    height: 44px;
    margin-bottom: 16px;
    box-sizing: border-box;
  }

  .login-page {
    position: fixed;
    width: 100%;
    height: 100%;
    background: url("../assets/img/web.jpg") no-repeat center;
    background-size: cover;
  }

  .login-page .login-body {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 500px;
    height: 660px;
    min-height: 0;
    max-height: 95vh;
    padding: 40px 48px;
    overflow-y: auto;
    transform: translate(-50%, -50%);
    box-shadow: 0 1px 4px rgb(0 0 0 / 50%);
  }
}
</style>
